const list = {
  path: 'systemSet',
  component: resolve => require(['@/pages/admin/system/systemSet'], resolve)
}

export default list
